import { Component, Renderer2 } from '@angular/core';
import { ViewTokenComponent } from '../view-token/view-token.component';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-appointment-token-tv-view',
    // standalone: true,
    // imports: [],
    templateUrl: './appointment-token-tv-view.component.html',
    styleUrls: ['./appointment-token-tv-view.component.scss'],
    standalone: false
})
export class AppointmentTokenTvViewComponent extends ViewTokenComponent {
  constructor(
    public baseService: BaseService,
    public alert: AlertsService,
    public renderer: Renderer2,
    public Aroute: ActivatedRoute
  ) {
    super(baseService, alert, renderer, Aroute);
  }

  calculateStyles(_hasLength: any, deskSize?):any {
    return (this.screenVisiblity[_hasLength] / _hasLength) + "%" 
  }

  checkIfPresent(array:any,key:any){
    return array.some((el:any) => el.stage === key);
  }

  
}
